import { STRINGS } from 'config';
import { ToolbarPatient, GetPatientFail, FETCHING } from 'model/toolbar/patient';
import { SuccessfulSaveToRecord, FailedSaveToRecord, SAVING } from 'model/toolbar/saveToRecord';
// import { reportError, reportInfo } from 'util/datadog';

const {
  REDUCERS: {
    TOOLBAR: {
      GET_CURRENT_PATIENT_REQUEST,
      GET_CURRENT_PATIENT_RESPONSE,
      GET_CURRENT_PATIENT_FAILED,
      WRITE_TO_RECORD_REQUEST,
      WRITE_TO_RECORD_RESPONSE,
      WRITE_TO_RECORD_FAILED,
      RESET_TOOLBAR_STATUS,
    },
  },
} = STRINGS;

export interface ToolbarState {
  patient: ToolbarPatient | GetPatientFail | typeof FETCHING | null;
  saveToRecordStatus: SuccessfulSaveToRecord | FailedSaveToRecord | typeof SAVING | null;
}

export const initialToolbarState: ToolbarState = {
  patient: null,
  saveToRecordStatus: null,
};

export const toolbarReducer = (state: any, action: any): ToolbarState => { // eslint-disable-line @typescript-eslint/no-explicit-any
  switch (action.type) {
    case GET_CURRENT_PATIENT_REQUEST: {
      return {
        ...initialToolbarState,
        patient: FETCHING,
      };
    }
    case GET_CURRENT_PATIENT_RESPONSE: {
      return {
        ...state,
        patient: {
          status: action.payload.status,
          patientId: action.payload.patientId,
          nhsNumber: action.payload.nhsNumber,
          firstName: action.payload.firstName,
          surname: action.payload.surname,
          dateOfBirth: action.payload.dateOfBirth,
        },
      };
    }
    case GET_CURRENT_PATIENT_FAILED: {
      return {
        ...state,
        patient: {
          status: action.payload.status,
        },
      };
    }
    case WRITE_TO_RECORD_REQUEST: {
      return {
        ...state,
        saveToRecordStatus: SAVING,
      };
    }

    case WRITE_TO_RECORD_RESPONSE: {
      return {
        ...state,
        saveToRecordStatus: {
          timeStamp: action.payload.timestamp,
        },
      };
    }
    case WRITE_TO_RECORD_FAILED: {
      return {
        ...state,
        saveToRecordStatus: {
          statusCode: action.payload.status,
        },
      };
    }
    case RESET_TOOLBAR_STATUS: {
      return initialToolbarState;
    }
    default: {
      return state;
    }
  }
};
